import React, { useState } from 'react'
import { OverlayTrigger, Tooltip as BTooltip } from 'react-bootstrap'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { cn } from '@utils/safeTs'

const Tooltip = ({ label, id, pos, size = 'md', className = undefined, children = undefined, containerClassName = undefined, dialog = false }) => {
  const overlay = (props) => (
    <BTooltip
      id={id}
      className={'tooltip tooltip--' + (size ? size : 'md') + (className ? ' ' + className : '')}
      {...props}
    >
      {label}
    </BTooltip>
  )

  const [show, setShow] = useState(false)
  const { width } = useWindowDimensions()
  const isMobile = width < 600

  const getContent = () => (
    <div
      onClick={() => {
        setShow(!show)
      }}
      onMouseEnter={() => {
        !isMobile && setShow(true)
      }}
      onMouseLeave={() => {
        setShow(false)
      }}
      className={cn(dialog ? 'tooltip-dialog__container' : undefined, containerClassName)}
    >
      {dialog && show ? (
        <div role="tooltip" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement={pos ? pos : 'top'} x-placement={pos ? pos : 'top'} className={cn('fade', 'tooltip', 'bs-tooltip-' + (pos ? pos : 'top'), 'tooltip--' + (size ? size : 'md'), show ? 'show' : undefined, className)}>
          <div class="arrow"></div>
          <div class="tooltip-inner">{label}</div>
        </div>
      ) : <></>}
      {children}
    </div>
  )

  return dialog ? (
    <>
      {getContent()}
    </>
  ) : (
    <OverlayTrigger
      placement={pos ? pos : 'top'}
      show={show}
      delay={{ show: 50, hide: 50 }}
      overlay={overlay}
    >
      {getContent()}
    </OverlayTrigger>
  )
}

export default Tooltip
